jQuery(document).ready(function($) {
  if (!$('.timeline').length) {
    return;
  }

  timelineShow($);
});

function timelineShow($) {
  if ($(window).width() > 767) {
    $(window).scroll(function() {
      var top_of_element = $('.timeline--row').offset().top;
      var bottom_of_element = $('.timeline--row').offset().top + $('.timeline--row').outerHeight();
      var bottom_of_screen = $(window).scrollTop() + $(window).innerHeight();
      var top_of_screen = $(window).scrollTop();

      if ((bottom_of_screen > top_of_element) && (top_of_screen < bottom_of_element)){
        $('.timeline--text, .timeline--arrow').fadeIn(1000);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/blocks/timeline.js